
import { Routes, Route } from 'react-router-dom'
import MarketingLayout from './pages/MarketingLayout'
import Marketing from './pages/Marketing'
import Features from './pages/Features'
import HowItWorks from './pages/HowItWorks'
import Pricing from './pages/Pricing'
import Security from './pages/Security'
import Login from './pages/Login'
import Signup from './pages/Signup'
import AuthCallback from './pages/AuthCallback'
import AppShell from './pages/AppShell'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import Deployments from './pages/Deployments'
import Settings from './pages/Settings'
import Profile from './pages/Profile'
import Docs from './pages/Docs'
import NotFound from './pages/NotFound'
import ProtectedRoute from './app/router/ProtectedRoute'

const App = () => {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Marketing />} />
        <Route path="/features" element={<Features />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/security" element={<Security />} />
      </Route>

      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/docs" element={<Docs />} />

      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="deployments" element={<Deployments />} />
        <Route path="settings" element={<Settings />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
